import { ArrowNarrowLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import BigNumber from "bignumber.js";
import { useEffect, useRef, useState } from "react";
import { usePopWindow } from "../components/BottomPopWindow";
import { CoinPanel, ErrorBar, FormInput, InformationBar, LoadingDialog, WalletAccount_Pop_List } from "../components/CommonComponents";
import Button from "../components/control/Button";
import { ListSelector } from "../components/ListSelector";
import { Icon_History, Icon_USER_CIRCLE, LoadingCircleSVG } from "../components/Svgs";
import { ToastType, useToast } from "../components/Toast";
import API from "../conf/API";
import { WAIdToName, WalletAccount } from "../conf/Config";
import { AddressBookView, PopWnd_AddressBook } from "../modules/AddressBook";
import DataCenter, { Calculator, CurrentCurrency, QuoteCoinID, TransactionMethod } from "../modules/DataCenter";
import { Localize, LocalStr } from "../modules/localize/Localize";
import { useTrans } from "../modules/TransactionService";
import { WalletService, WalletTxInfo } from "../modules/WalletService";
import { post } from "../utils/request";
import { addressEquals } from "../utils/Utils";
import { TransactionHistory_View } from "./TransactionOrderView";


export const TopupView = ({ addView, fireViewAction, walletAccount }) => {
    const coinPanels = [];
    if (DataCenter.hasSymbolData()) {
        const coins = DataCenter.getCoins();
        const l = coins.length;
        for (let i = 0; i < l; i++) {
            const coin = coins[i];
            coinPanels.push(<CoinPanel coin={coin} key={coin.id} wallet={WalletAccount.DeFi} hideFrozen={true} includeFrozen={false} onClick={
                ({ coin, wallet }) => {
                    addView(TopupView_Topup, "left", null, action => { },
                        {
                            addView: addView,
                            coin: coin,
                            walletAccount: walletAccount
                        })
                }
            } />);
            if (i < l - 1)
                coinPanels.push(<div className='w-full h-[1px] bg-gray-100' key={coin.id + 100000000} />)
        }
    }


    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">{
                Localize.getMsg(Localize.UI.TopupView.title)
            }</div>
        </div>
        <div className="pt-2 font-semibold flex w-full">
            <div className="flex-1">{Localize.getMsg(Localize.UI.TopupView.coin_list_title)}</div>
            <div>{Localize.getMsg(Localize.UI.TopupView.coin_list_title_right)}</div>
        </div>
        {coinPanels}
    </div>
}

const TopupView_Topup = ({ addView, fireViewAction, coin, walletAccount, clearView }) => {
    const [selAddr, setSelAddr] = useState(null);
    const [transferNet, setTransferNet] = useState(WalletService.blockchain);
    const [addrTo, setAddrTo] = useState("");
    const [sendAmount, setSendAmount] = useState("");
    const [sendEnable, setSendEnable] = useState(false);
    const [calc, setCalc] = useState(false);
    const [txInfo, setTxInfo] = useState(null);
    const [recvAcc, setRecvAcc] = useState(walletAccount)
    const [accAvailable, setAccAvailable] = useState({})
    const [errMsg, setErrMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [pop] = usePopWindow();
    const [makeToast] = useToast();
    const [_, addTrans] = useTrans();

    const quoteCoin = DataCenter.getCoin(QuoteCoinID);

    const sendAcc = WalletAccount.DeFi;

    const calcSend = (coin, sendAmount) => {
        setCalc(true);
        const amount = Calculator.toBigNumber(sendAmount, coin.id)
        const body = {
            coinType: coin.id,
            walletAccount: sendAcc,
            txMethod: TransactionMethod.Topup,
            transferNet: transferNet.key,
            amount: amount.toFixed(),
            txFrom: WalletService.address().toString(),
            txTo: recvAcc,
        }
        post(API.wallet_trans_fee(), body).then(async ret => {
            if (ret.error) {
                console.log(ret);
            } else {
                const ti = new WalletTxInfo(ret.retObject);
                setTxInfo(ti);
                ti.gasPrice = new BigNumber(ti.gasPrice);
                ti.gasUsed = new BigNumber(ti.gasUsed);
                ti.getGasFee = () => {
                    // const p = ti.gasPrice.times(ti.gasUsed);
                    // const p1 = Calculator.toNumber(p, QuoteCoinID).toTrimed(2, quoteCoin.showDecimals);
                    // return p1;
                    return WalletService.provider.calcGasFee(ti.gasPrice, ti.gasUsed, quoteCoin).str;
                }
                ti.getAmount = (excludeGasFee = true) => {
                    const g = new BigNumber(ti.getGasFee());
                    const a = Calculator.toNumber(ti.amount, coin.id)
                    return excludeGasFee && ti.coinType == QuoteCoinID ? a.minus(g) : a;
                }
                ti.getTxFrom = () => {
                    if (WalletService.isDeFiWalletAddr(ti.txFrom)) {
                        return "DeFi钱包"
                    }
                    return ti.txFrom;
                }
                ti.getTxTo = () => {
                    if (WalletService.isDeFiWalletAddr(ti.txTo)) {
                        return "DeFi钱包"
                    }
                    return ti.txTo;
                }

                //检查账户中是否有足够的QuoteCoin支付手续费
                const gasFee = WalletService.provider.calcGasFee(ti.gasPrice, ti.gasUsed, quoteCoin).bn;
                let balance = null;
                if (sendAcc == WalletAccount.DeFi) {
                    //从DeFi钱包中发送，检查钱包中的余额
                    balance = await WalletService.walletInfo.balance(quoteCoin);
                } else {
                    //从MetaVirus账户中发送，检查对应的钱包账户
                    balance = DataCenter.walletBalance(sendAcc, quoteCoin.id);
                }
                if (gasFee.isGreaterThan(balance)) {
                    setSendEnable(false);
                    setErrMsg(Localize.getMsg(
                        Localize.Msg.Trade_NotEnoughCoin,
                        WAIdToName(sendAcc),
                        quoteCoin.name,
                        ti.getGasFee() + " " + quoteCoin.name
                    ))
                } else {
                    setErrMsg("");
                    setSendEnable(true);
                }
            }
            setCalc(false);
        })
    }

    useEffect(() => {
        const valid = sendAmount != "" && sendAmount.isGreaterThan(0);
        if (valid && !calc) {
            calcSend(coin, sendAmount);
        }
    }, [addrTo, sendAmount])

    useEffect(() => {
        const { walletInfo } = WalletService;

        const available = {
            [WalletAccount.TradeAccount]: DataCenter.walletBalance(WalletAccount.TradeAccount, coin.id, false),
            [WalletAccount.GameAccount]: DataCenter.walletBalance(WalletAccount.GameAccount, coin.id, false),
        }

        if (walletInfo != null) {
            walletInfo.balance(coin).then(
                ret => {
                    available[WalletAccount.DeFi] = ret;
                    setAccAvailable(available);
                }
            );
        } else {
            setAccAvailable(available);
        }
    }, [])

    const total = accAvailable[sendAcc] || new BigNumber(0);

    const inputSend = useRef();

    return <div className="flex flex-col w-full h-full bg-white ">
        <div className="flex flex-col w-full h-full bg-white p-4">
            <div className=' w-full h-8 flex flex-row items-center justify-center'>
                <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" onClick={() => fireViewAction({ name: "close" })} />
                <div className="flex flex-1 font-semibold justify-center items-center pl-8 text-xl" onClick={() => fireViewAction({ name: "close" })}>
                    <LocalStr msg={Localize.COMMON.Topup} />&nbsp;{[coin.name]}
                </div>
                <div className="flex" onClick={e => {
                    addView(TransactionHistory_View, "left", null, action => {

                    }, { addView: addView })
                }}><Icon_History className="w-14 h-6 px-4" /></div>
            </div>
            <div className="flex flex-col w-full pt-4 flex-1">
                <LocalStr msg={Localize.COMMON.SendAccount} className="text-gray-500 text-sm" />
                <div className="flex rounded-md mt-1 text-base px-3 py-2 bg-gray-100 font-semibold">
                    {WAIdToName(WalletAccount.DeFi)} - {
                        Localize.getMsg(Localize.COMMON.Balance) + " " + total.toTrimed(2, coin.showDecimals) + " " + coin.name
                    }
                </div>

                <div className="text-gray-500 text-sm pt-4">转账网络</div>
                <div className=" bg-gray-100 px-3 py-2 rounded-md mt-1">
                    {transferNet.text}
                </div>

                <div className="text-gray-500 text-sm pt-4">充值金额</div>
                <div className="flex rounded-md mt-1  items-center">
                    <div className="flex flex-1">
                        <FormInput ref={inputSend} placeholder="最少0" type="number"
                            onReset={e => {
                                setSendAmount("");
                                setTxInfo(null);
                            }}
                            suffix={<div className="flex">
                                <div className="text-gray-400 pr-1">{coin.name}</div>
                                <div className="text-link flex pr-3" onClick={e => {
                                    if (inputSend.current) {
                                        inputSend.current.setValue(total.toTrimed(2));
                                    }
                                }}>全部充值</div>
                            </div>}
                            validInput={(name, value) => {
                                if (value == "") return;
                                const v = new BigNumber(value);
                                if (v.isGreaterThan(total)) {
                                    setSendAmount("")
                                    setTxInfo(null);
                                    return "余额不足"
                                }
                                setSendAmount(v)
                            }} />
                    </div>

                </div>

                <LocalStr msg={Localize.COMMON.RecvAccount} className="text-gray-500 text-sm pt-4" />
                <div className="text-gray-600 text-base bg-gray-100 px-3 py-2 rounded-md flex" onClick={
                    e => {
                        pop("pop_list_walletaccount", WalletAccount_Pop_List, Localize.getMsg(Localize.COMMON.SelRecvAccount), action => {
                            if (action.name == "select") {
                                const item = action.value;
                                setRecvAcc(item.id);
                            }
                        }, { walletAccount: recvAcc, coin: coin, includeDeFi: false });
                    }}>
                    <div className="flex-1">{WAIdToName(recvAcc)} - {Localize.getMsg(Localize.COMMON.Balance)} {accAvailable[recvAcc] == null ? "" : accAvailable[recvAcc].toTrimed(2)} {coin.name}</div>
                    <div className="w-6 h-6"><ChevronRightIcon className="w-6 h-6" /></div>
                </div>

                {
                    errMsg == "" || errMsg == null ? null : <ErrorBar text={errMsg} />
                }

                {/*<div className="flex text-gray-600 text-sm pt-4 font-semibold">
                    <div className="flex-1">可用</div>
                    <div className="pr-3">{total.toTrimed(2)} {coin.name}</div>
                </div>
                 <div className="flex flex-col text-sm text-gray-500 bg-gray-100 px-3 py-2 rounded-md mt-1">
                    <div className="flex">
                        <div className="flex-1">{WalletAccountName[WalletAccount.TradeAccount]}</div>
                        <div className="">{available[WalletAccount.TradeAccount].toTrimed(2, coin.showDecimals)} {coin.name}</div>
                    </div>
                    <div className="flex pt-2">
                        <div className="flex-1">{WalletAccountName[WalletAccount.GameAccount]}</div>
                        <div className="">{available[WalletAccount.GameAccount].toTrimed(2, coin.showDecimals)} {coin.name}</div>
                    </div>
                </div> */}
            </div>
        </div>
        <div className="h-[1px] bg-gray-100 w-full"></div>
        <div className="flex p-4 pb-8 w-full">
            <div className="flex flex-col flex-1 bg-white">
                <div className="text-sm text-gray-500">充值金额</div>
                <div className="flex items-end">
                    {calc ? <div className="text-link w-6 h-6">{LoadingCircleSVG}</div> : null}
                    <div className="text-xl font-semibold">{txInfo == null || txInfo.getAmount == null ? "0.00" : txInfo.getAmount().toTrimed(2)}</div>
                    <div className="font-semibold pl-1">{coin.name}</div>
                </div>
                <div className="text-sm text-gray-500">网络手续费 {txInfo == null || txInfo.getGasFee == null ? "0.00" : txInfo.getGasFee()} {quoteCoin.name}</div>
            </div>
            <div className="flex flex-col items-center justify-center">
                <Button name={Localize.getMsg(Localize.COMMON.Topup)} type="primary" padding="py-2" disabled={!sendEnable || txInfo == null}
                    onClicked={e => {
                        txInfo.txTo = recvAcc;
                        pop("pop_send_review", TopupView_Pop_Review, "确认订单", action => {
                            if (action.name == "ok") {
                                txInfo.txTo = recvAcc;
                                setLoading(true);
                                post(API.wallet_trans_do(), txInfo.requestBody()).then(async ret => {
                                    if (ret.error) {
                                        makeToast(Localize.getCodeMsg("DefiWallet", ret.code),
                                            ToastType.wrong, "topup_submitted_error");
                                        setLoading(false);
                                        return;
                                    }
                                    const info = new WalletTxInfo(ret.retObject);
                                    addTrans(info);
                                    try {
                                        await WalletService.provider.transfer(info);
                                        makeToast(Localize.getMsg(Localize.UI.TopupView.order_submitted),
                                            ToastType.right, "topup_submitted");
                                        setLoading(false);
                                    } catch (e) {
                                        console.error(e);
                                    }
                                    clearView();
                                })

                            }
                        }, { txInfo })
                    }} />
            </div>
        </div>
        <LoadingDialog show={loading} />
    </div>
}


const TopupView_Pop_Review = ({ onViewAction, txInfo }) => {
    const coin = DataCenter.getCoin(txInfo.coinType);
    const quoteCoin = DataCenter.getCoin(QuoteCoinID);
    const currency = CurrentCurrency();
    const price = DataCenter.getCoinQuotePrice(coin.id, quoteCoin.id, currency.name);

    const recvAcc = WAIdToName(txInfo.getTxTo());
    const topupBalance = txInfo.getAmount().toTrimed(2, coin.showDecimals) + " " + coin.name

    return <>
        <LocalStr msg={Localize.UI.TopupView.will_topup} className="text-gray-400 text-sm flex justify-center" />
        <div className="text-2xl font-semibold flex justify-center text-black pt-1">
            {topupBalance}
        </div>
        <div className="text-gray-400 text-xs flex justify-center">
            ≈ {currency.symbol}{price.times(txInfo.getAmount()).toTrimed(currency.decimals, currency.decimals)}
        </div>

        <div className="bg-gray-100 w-full  flex flex-col p-3 text-gray-500 rounded-md mt-3">
            <div className="flex w-full">
                <div className="flex-1 flex items-center">充值来源</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{WAIdToName(txInfo.walletAccount)}</div>
            </div>
            <div className="flex w-full pt-2">
                <div className="flex-1 flex items-center">接收账户</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{recvAcc}</div>
            </div>
            <div className="flex w-full pt-2">
                <div className="flex-1 flex items-center">转账网络</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{WalletService.blockchain.text}</div>
            </div>
            <div className="w-full h-[1px] bg-gray-200 my-4"></div>
            <div className="flex w-full">
                <div className="flex-1 flex items-center">充值币种</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{coin.name}</div>
            </div>
            <div className="flex w-full pt-2">
                <div className="flex-1 flex items-center">充值总额</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{txInfo.getAmount(false).toTrimed(2, coin.showDecimals)} {coin.name}</div>
            </div>
            <div className="flex w-full pt-2">
                <div className="flex-1 flex items-center">网络手续费</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{txInfo.getGasFee()} {quoteCoin.name}</div>
            </div>
            <div className="flex w-full pt-2">
                <div className="flex-1 flex items-center">到账金额</div>
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{topupBalance}</div>
            </div>
        </div>
        <div className="flex w-full">
            <InformationBar text="请确保您输入了正确的地址，并且地址与转账网络相匹配。订单创建后不可取消。" />
        </div>

        <div className="flex w-full pt-3">
            <Button type="primary" name="确定" widthStyle="w-full" padding="py-2" className="font-semibold text-lg"
                onClicked={e => {
                    onViewAction("ok")
                    onViewAction("close")
                }} />
        </div>
    </>
}